export class ValidateOTPRequest {
  otpRequestID: string;
  otp: string;

  constructor(otpRequestID: string, otp: string) {
    this.otpRequestID = otpRequestID;
    this.otp = otp;
  }
}
